<template>
  <div class="details-view">
    <div class="main-content hrRealGPReport">
      <div class="section form-column" style="width: 1350px;">
        <el-form :inline="true" label-width="60px" label-position="center" style="margin-top: 5px;">
          <el-form-item label-width="100px" label="Month From">
            <el-select v-model="copyMonthFrom" no="copyMonthFrom" style="width: 120px;">
              <el-option v-for="(item,index) in copyMonths" :key="index" :label="copyMonthLabelFun(item)" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label-width="40px" label="To">
            <el-select v-model="copyMonthTo" no="copyMonthTo" style="width: 120px;">
              <el-option v-for="(item,index) in copyMonths" :key="index" :label="copyMonthLabelFun(item)" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_BranchCMP')">
            <cargo-advance-select
              no="branchId"
              :select-type="selectTypeNames.basic_data_Office"
              :clearable="false"
              filterable
              :default-value="branchId"
              tag-value="officeId"
              tag-name="code"
              :filter-tag-names="['englishName','chineseName','code']"
              :cache="false"
              :static-options="currentOfficeList"
              :placeholder="' '"
              style="width: 120px;"
              @parentCallBack="p=>{currentOfficeIdChange(p.value)}"
            />
          </el-form-item>
          <el-form-item style="margin-bottom: 15px!important;">
            <el-button no="dataExport" type="primary" @click="printHandler">{{ $t('CargoMsg.Cargo_DataExport') }}</el-button>
            <span style="font-size:13px;color:orange; margin-left: 25px;">{{ lastMonthlyDate }}</span>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :printed-callback="templateSelectorDialog.printedCallback"
    />
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'TabFinanceReport',
  components: { cargoAdvanceSelect, cargoTemplateSelectorDialog },
  props: {
    copyMonthList: { type: Array, default: () => [] },
    latestMonthlyDate: { type: String, default: '' }
  },
  data() {
    return {
      loading: false,
      selectTypeNames: TYPE_NAMES,
      copyMonthFrom: '', // Month From
      copyMonthTo: '', // Month To
      branchId: 0, // 分公司ID
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'PillAccrueReport',
        data: {
          JOB_UUID: [],
          LOB: 'SE'
        },
        printedCallback: null
      }
    }
  },
  computed: {
    copyMonths() {
      return this.copyMonthList || []
    },
    lastMonthlyDate() {
      return 'Last archive date ' + ColumnUtils.dateTimeLabelFunc(this.latestMonthlyDate)
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    // 分公司列表
    currentOfficeList() {
      return this.$store.state.user.userInfo.currentUserOfficeList
    }
  },
  created() {

  },
  methods: {
    copyMonthLabelFun(data) {
      if (data && data.length === 6) {
        return data.substr(0, 4) + '-' + Number(data.substr(4)) + (this.$store.getters.language === 'zh' ? '月' : ' Month')
      }
      return data
    },
    printHandler() {
      if (!this.copyMonthFrom) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + ' Month From')
        return
      }
      if (!this.copyMonthTo) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + ' Month To')
        return
      }
      if (!this.branchId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_BranchCMP'))
        return
      }
      const params = {}
      params.copyMonthFrom = this.copyMonthFrom
      params.copyMonthTo = this.copyMonthTo
      params.pillBranchId = this.branchId // 分公司ID
      params.monthlyDataMark = 1 // 月度数据
      params.financeMark = 1 // 财务数据
      params.hrMark = 0 // HR数据
      params.USER_UUID = this.$store.getters.userInfo.userId
      params.classNameType = SystemConstants.ACT
      console.log('doPrint', params)
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
    },
    // 默认值
    setDefaultCondition() {
      if (this.copyMonths.length > 0) {
        this.copyMonthFrom = this.copyMonths[0]
        this.copyMonthTo = this.copyMonths[0]
      }
    },
    currentOfficeIdChange(val) {
      this.branchId = val || 0
    }
  }
}
</script>

<style lang="scss">

</style>
